// extracted by mini-css-extract-plugin
module.exports = {"paper":"BrushPaper_paper__bgmxM","washes":"BrushPaper_washes__1rS1g","painted":"BrushPaper_painted__4fBDs","vignette":"BrushPaper_vignette__i443B"};